import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
`

export const SegmentedControl = styled.div`
  display: inline-flex;
  align-items: center;

  padding: 5px;
  gap: 10px;

  border-radius: 5px;
  background: #e1eaff;
  // background: linear-gradient(180deg, #f1f2ff 88.65%, #fdfdff 100%);

  width: fit-content;
  hieght: 40px;

  opacity: ${({disabled}) => (disabled ? 0.55 : 1)};
  pointer-events: ${({disabled}) => (disabled ? 'not-allowed' : 'pointer')};
`

export const SegmentButton = styled.button`
  border: ${({isSelected}) => (isSelected ? '1px solid #0327A9' : 'none')};
  outline: none;
  display: flex;
  background: ${({isSelected}) => (isSelected ? '#ffffff' : 'transparent')};

  color: ${({isSelected}) => (isSelected ? '#0327A9' : '#4b5563')};

  font-size: 12px;

  font-weight: ${({isSelected}) => (isSelected ? 600 : 500)};

  padding: 10px 20px;

  border-radius: 5px;

  cursor: pointer;

  transition: background 180ms ease, color 180ms ease, box-shadow 180ms ease;

  box-shadow: ${({isSelected}) =>
    isSelected
      ? '0 1px 2px rgba(0,0,0,0.08), 0 1px 6px rgba(0,0,0,0.04)'
      : 'none'};

  white-space: nowrap;

  &:hover {
    color: #111827;
  }
`

export const TooltipWrapper = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  margin-left: 6px;
`

export const TooltipIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 16px;
  height: 16px;

  color: #9ca3af;

  transition: color 160ms ease;

  &:hover {
    color: #6b7280;
  }
`

export const TooltipContent = styled.div`
  position: absolute;

  bottom: calc(100% + 10px);
  left: 50%;

  transform: translateX(-50%);

  width: 220px;

  padding: 10px 12px;

  border-radius: 10px;

  background: #111827;
  color: #ffffff;

  font-size: 12px;
  line-height: 1.5;
  font-weight: 500;

  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0, 0, 0, 0.1);

  opacity: 0;
  visibility: hidden;

  transition: opacity 160ms ease, visibility 160ms ease, transform 160ms ease;

  pointer-events: none;

  .tooltip-trigger:hover & {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(-2px);
  }

  &::after {
    content: '';

    position: absolute;

    top: 100%;
    left: 50%;

    transform: translateX(-50%);

    border-width: 6px;
    border-style: solid;

    border-color: #111827 transparent transparent transparent;
  }
`

// import styled from '@emotion/styled'

// export const Container = styled.div`
//   width: 100%;
// `

// export const Header = styled.div`
//   margin-bottom: 24px;
// `

// export const Title = styled.h2`
//   font-size: 24px;
//   font-weight: 700;
//   margin: 0 0 8px;
// `

// export const Subtitle = styled.p`
//   margin: 0;
//   color: #6b7280;
//   font-size: 14px;
// `

// export const ToggleWrapper = styled.div`
//   display: flex;
//   gap: 16px;

//   @media (max-width: 768px) {
//     flex-direction: column;
//   }
// `

// export const ToggleButton = styled.button`
//   position: relative;
//   flex: 1;
//   display: flex;
//   align-items: center;
//   gap: 14px;

//   padding: 18px;
//   border-radius: 18px;

//   border: 1px solid ${({isSelected}) => (isSelected ? '#2563EB' : '#E5E7EB')};

//   background: ${({isSelected}) => (isSelected ? '#EFF6FF' : '#FFFFFF')};

//   transition: all 180ms ease;

//   cursor: pointer;
//   text-align: left;

//   &:hover {
//     border-color: #2563eb;
//     transform: translateY(-1px);
//   }
// `

// export const ToggleIndicator = styled.div`
//   position: absolute;
//   top: 12px;
//   right: 12px;

//   width: 10px;
//   height: 10px;
//   border-radius: 999px;

//   background: ${({isSelected}) => (isSelected ? '#2563EB' : '#D1D5DB')};

//   transition: all 180ms ease;
// `

// export const IconWrap = styled.div`
//   width: 46px;
//   height: 46px;

//   display: flex;
//   align-items: center;
//   justify-content: center;

//   border-radius: 14px;

//   background: ${({isSelected}) => (isSelected ? '#2563EB' : '#F3F4F6')};

//   color: ${({isSelected}) => (isSelected ? '#FFFFFF' : '#6B7280')};

//   transition: all 180ms ease;
// `

// export const ToggleContent = styled.div`
//   flex: 1;
// `

// export const ToggleLabel = styled.div`
//   font-size: 16px;
//   font-weight: 600;

//   color: ${({isSelected}) => (isSelected ? '#111827' : '#1F2937')};
// `

// export const ToggleHint = styled.div`
//   margin-top: 4px;
//   font-size: 13px;
//   color: #6b7280;
// `
// // import styled from '@emotion/styled'
// // import {theme} from '../../theme'

// // export const Container = styled.section`
// //   display: flex;
// //   flex-direction: column;
// //   gap: ${theme.space[5]};
// // `

// // export const Header = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   gap: ${theme.space[1]};
// // `

// // export const Title = styled.h2`
// //   font-size: ${theme.fontSizes.base};
// //   font-weight: ${theme.fontWeights.bold};
// //   color: ${theme.colors.text.primary};
// //   margin: 0;
// // `

// // export const Subtitle = styled.p`
// //   font-size: ${theme.fontSizes.md};
// //   color: ${theme.colors.text.secondary};
// //   margin: 0;
// // `

// // // Outer card matching the white rounded container in the wireframe
// // export const TilesCard = styled.div`
// //   background: ${theme.colors.bg.primary};
// //   border-radius: ${theme.radii.sm};
// //   border: 1px solid ${theme.colors.border.light};
// //   padding: ${theme.space[8]};
// //   display: flex;
// //   justify-content: center;
// // `

// // export const TilesRow = styled.div`
// //   display: flex;
// //   gap: ${theme.space[4]};
// // `

// // // Individual tile button
// // export const TileButton = styled.button`
// //   display: flex;
// //   flex-direction: column;
// //   align-items: center;
// //   justify-content: center;
// //   gap: ${theme.space[3]};
// //   background: ${theme.colors.bg.primary};
// //   width: 135px;
// //   height: 95.4px;
// //   border-radius: ${theme.radii.sm};
// //   cursor: pointer;
// //   transition: border ${theme.transitions.normal},
// //     background ${theme.transitions.normal},
// //     box-shadow ${theme.transitions.normal};

// //   /* Selected: dark border + white bg */
// //   /* Unselected: no border + light grey bg */
// //   border: ${({isSelected}) =>
// //     isSelected
// //       ? `2px solid ${theme.colors.bg.inverse}`
// //       : `1px solid ${theme.colors.border.light}`};

// //   background: ${({isSelected}) =>
// //     isSelected ? theme.colors.bg.brand : theme.colors.bg.brand};

// //   box-shadow: ${({isSelected}) => (isSelected ? theme.shadows.sm : 'none')};

// //   &:hover:not(:disabled) {
// //     border-color: ${theme.colors.border.strong};
// //     background: ${theme.colors.bg.brand};
// //   }

// //   &:focus-visible {
// //     outline: 2px solid ${theme.colors.border.focus};
// //     outline-offset: 2px;
// //   }
// // `

// // export const TileIconWrapper = styled.div`
// //   width: 30px;
// //   height: 30px;
// //   border-radius: ${theme.radii.sm};
// //   background: ${theme.colors.border.default};
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   overflow: hidden;
// // `

// // export const TileLabel = styled.span`
// //   font-size: ${theme.fontSizes.sm};
// //   font-weight: ${({isSelected}) =>
// //     isSelected ? theme.fontWeights.semibold : theme.fontWeights.regular};
// //   color: ${theme.colors.text.primary};
// //   text-align: center;
// // `
